import { Popover, PopoverTrigger, PopoverContent, PopoverBody, IconButton, Icon, Portal } from '@chakra-ui/react';
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import { EmojiData } from 'emoji-mart';
import { FC } from 'react';

import EmojiIcon from '@/assets/icons/ic-emoji.svg';

interface IChatEmojiPickerProps {
  onEmojiSelect: (emoji: EmojiData) => void;
}

export const ChatEmojiPicker: FC<IChatEmojiPickerProps> = ({ onEmojiSelect }) => {
  return (
    <Popover
      placement="top-end"
      offset={[50, 20]}
      returnFocusOnClose={false}
      isLazy
      lazyBehavior="unmount"
      // this is necessary because https://github.com/chakra-ui/chakra-ui/issues/3461
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={false}
    >
      <PopoverTrigger>
        <IconButton
          variant="link"
          colorScheme="violet"
          aria-label="emoji popup"
          mr={3}
          alignSelf="center"
          maxW="min-content"
          minW="max-content"
        >
          <Icon w="24px" h="24px" color="violet.500" as={EmojiIcon} />
        </IconButton>
      </PopoverTrigger>
      <Portal>
        <PopoverContent w="full" borderWidth={1} borderRadius="xl">
          <PopoverBody p={0}>
            <Picker theme="light" perLine={8} data={data} onEmojiSelect={onEmojiSelect} />
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
